import { Conversation } from "@/pages/Private/pages/Apollo/schema/get-people";

/** The conversation types that belong to an email thread. */
const EMAIL_TYPES = ["mail_sent", "mail_received", "mail_scheduled"];

/**
 * The email thread a reply to this lead belongs to, or `""` when there is none.
 *
 * Only conversations of the campaign being replied to count, newest first — a lead can carry mail
 * from several campaigns, and replying inside the wrong thread sends the message to the wrong
 * conversation. LinkedIn conversations never carry a `threadId`, so they drop out here.
 */
export const resolveSendThreadId = (
	conversations: Conversation[],
	campaignId: string | null | undefined
): string => {
	const sorted = [...conversations].sort(
		(a, b) => new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime()
	);

	return (
		sorted
			.filter((c) => c.campaignId === campaignId && EMAIL_TYPES.includes(c.type))
			.find((c) => !!c.threadId)?.threadId || ""
	);
};
